export enum FormInstanceStatus {
  Available = 'AVAILABLE',
  Open = 'OPEN',
  Draft = 'DRAFT',
  Submitted = 'SUBMITTED',
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  Reopen = 'REOPEN',
  Expiring = 'EXPIRING',
}

// Default export needed because of an error in the frontend:
// `The requested module '[...]/@dep_common_form-api_types_form-instance-status__enum.js?v=bda269ea' does not provide an export named 'default'.`
export default FormInstanceStatus;
